{
  "dataUpdatedSuccessfully": {
    "type": "success",
    "header": "Success",
    "body": "Data have been updated."
  },
  "accountCreatedSuccessfully": {
    "type": "success",
    "header": "Success",
    "body": "Account has been created."
  },
  "accountUpdatedSuccessfully": {
    "type": "success",
    "header": "Success",
    "body": "Account has been updated."
  },
  "profileUpdatedSuccessfully": {
    "type": "success",
    "header": "Success",
    "body": "Profile updated successfully."
  },
  "profileCouldNotBeUpdated": {
    "type": "error",
    "header": "Error",
    "body": "Profile could not be updated."
  },
  "accountDeletedSuccessfully": {
    "type": "success",
    "header": "Success",
    "body": "Account has been deleted."
  },
  "dataUpdatedWithErrors": {
    "type": "error",
    "header": "Error",
    "body": "Data could not be updated."
  },
  "accountCouldNotBeCreated": {
    "type": "error",
    "header": "Error",
    "body": "Your account could not be created."
  },
  "accountCouldNotBeUpdated": {
    "type": "error",
    "header": "Error",
    "body": "Your account could not be updated."
  },
  "dataUpdateProblems": {
    "type": "warning",
    "header": "Warning",
    "body": "Some of your transactions may not have been updated."
  },
  "dataUpdateError": {
    "type": "error",
    "header": "Error",
    "body": "We could not update your data. Please check your network connection."
  },
  "projectUpdateError": {
    "type": "error",
    "header": "Error",
    "body": "We could not update your project. Please check your network connection."
  },
  "dataUpdateErrorContents": {
    "type": "error",
    "header": "Error",
    "body": "We could not update your data. Please check the form values and try again."
  },
  "checkYourData": {
    "type": "error",
    "header": "Error",
    "body": "Data could not be saved. Error messages are in cell comments."
  },
  "fileUploadAbortedSuccessfully": {
    "type": "success",
    "header": "Success",
    "body": "File upload cancelled. Data have not been changed."
  },
  "surveySendingError": {
    "type": "error",
    "header": "Survey sending error",
    "body": "We could not send your data."
  },
  "surveySentSuccessfully": {
    "type": "success",
    "header": "Thank you!",
    "body": "Survey has been sent successfully."
  },
  "transactionNotSelected": {
    "type": "error",
    "header": "No transaction selected",
    "body": "Please select a transaction to link the fee to."
  },
  "symbolNotSelected": {
    "type": "error",
    "header": "No stock selected",
    "body": "Please select the stock and account combination which generated the dividend."
  },
  "incorrectPassword": {
    "type": "error",
    "header": "Incorrect password",
    "body": "The current password was incorrect."
  },
  "attemptLimitExceeded": {
    "type": "error",
    "header": "Too many attempts",
    "body": "The system detected several password change attempts within the last few minutes. For security reasons it is now not possible to change your password. Please try again in 15 minutes."
  },
  "fileTooLarge": {
    "type": "error",
    "header": "File too large",
    "body": "We can only process files smaller than 5MB."
  },
  "fileUploadError": {
    "type": "warning",
    "header": "File upload failed",
    "body": "Some files failed to upload."
  },
  "noDataForDateFilter": {
    "type": "error",
    "header": "No data found",
    "body": "There are no data for this period. Back to previously selected period."
  },
  "transactionCreatedSuccess": {
    "type": "success",
    "header": "Success",
    "body": "Transaction created successfully."
  },
  "transactionCreatedError": {
    "type": "error",
    "header": "Error",
    "body": "Transaction could not be created."
  },
  "applyProjectTemplateSuccess": {
    "type": "success",
    "header": "Success",
    "body": "Template applied successfully."
  },
  "applyProjectTemplateError": {
    "type": "error",
    "header": "Error",
    "body": "We could not apply the template."
  },
  "noLinkedAccount": {
    "type": "error",
    "header": "Error",
    "body": "Your asset account has no linked bank account. Update your account details first."
  },
  "errorUpdatingStripe": {
    "type": "error",
    "header": "Email change incomplete",
    "body": "Your email was changed, but we could not update your payment contact email. Please reach out to our support."
  },
  "existingBankConnectionDetected": {
    "type": "info",
    "header": "Bank login already exists",
    "body": "You have already logged in to this bank. Bypassing bank login."
  },
  "newsletterSubscriptionSuccess": {
    "type": "success",
    "header": "Success",
    "body": "You have successfully registered to our newsletter."
  },
  "newsletterSubscriptionError": {
    "type": "error",
    "header": "Error",
    "body": "We could not register you to our newsletter."
  },
  "noMoreAccountsAllowed": {
    "type": "error",
    "header": "Error",
    "body": "You have reached the maximum number of accounts allowed for your subscription plan."
  },
  "inconsistentAssetTransactions": {
    "type": "warning",
    "header": "Warning",
    "body": "The asset transactions for {{displayName}} in account {{accountName}} are not in the same currency."
  },
  "moreThan1ConnectedAccountFound": {
    "type": "warning",
    "header": "Warning",
    "body": "This asset account is linked to more than 1 deposit account."
  },
  "gridGetPurchaseValuesNoRows": {
    "type": "warning",
    "header": "No suitable rows found",
    "body": "Provide asset details (weight, purity...) or remove price."
  },
  "generalError": {
    "type": "error",
    "header": "Error",
    "body": "The application encountered an error. Please try again later."
  },
  "validationError": {
    "type": "error",
    "header": "Error",
    "body": "Data incorrect - validation failed."
  },
  "renewAccountAccessSuccess": {
    "type": "success",
    "header": "Success",
    "body": "Account access renewed successfully."
  },
  "renewAccountAccessCancelled": {
    "type": "success",
    "header": "Success",
    "body": "Process cancelled successfully."
  },
  "renewAccountAccessError": {
    "type": "error",
    "header": "Error",
    "body": "We were unable to renew your account access. Please contact our support team."
  },
  "unableToUpdateAllTransactions": {
    "type": "warning",
    "header": "Warning",
    "body": "unable to update all transactions"
  }
}
